import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import Modal from 'react-responsive-modal'
import CouponActions from '../../Redux/CouponRedux'

class ViewCoupon extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      data: []
    }
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (modalId === 'view-user') {
      this._fetchClaimers()
    }
  }

  _fetchClaimers = () => {
    this.props.getDetail({ id: this.props.detail.id })
  }

  render () {
    return (
      <section className='section' style={{ width: '80vw' }}>
        <div className='title-block'>
          <h3 className='title'>View Coupon</h3>
        </div>
        <div className='row'>
          <div className='col-6'>
            <div className='section'>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Title</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.title || '-'}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Code</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.code || '-'}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Type</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.type || '-'}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Status</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.status || '-'}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Platform</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.platform || '-'}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Product Type</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.product_type || '-'}
                </div>
              </div>
              {
                this.props.detail.product_type === 'modem' &&
                <div className='form-group row'>
                  <div className='col-4'>
                    <label className='control-label'>Rent Type</label>
                  </div>
                  <div className='col-8'>
                    {this.props.detail.rent_type || '-'}
                  </div>
                </div>
              }
              {
                this.props.detail.product_type === 'modem' &&
                <div className='form-group row'>
                  <div className='col-4'>
                    <label className='control-label'>Travel Start</label>
                  </div>
                  <div className='col-8'>
                    {this.props.detail.travel_date_start || '-'}
                  </div>
                </div>
              }
              {
                this.props.detail.product_type === 'modem' &&
                <div className='form-group row'>
                  <div className='col-4'>
                    <label className='control-label'>Travel End</label>
                  </div>
                  <div className='col-8'>
                    {this.props.detail.travel_date_end || '-'}
                  </div>
                </div>
              }
              {
                this.props.detail.product_type === 'modem' &&
                <div className='form-group row'>
                  <div className='col-4'>
                    <label className='control-label'>Min Duration</label>
                  </div>
                  <div className='col-8'>
                    {this.props.detail.min_duration || '- No Restriction -'}
                  </div>
                </div>
              }
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Max Usage</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.max_usage}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Max Usage Per User</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.max_usage_per_user}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Discount Type</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.discount_type.replace('_', ' ') || '-'}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Discount Amount</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.discount_amount || 0}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Min Amount</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.min_amount || 0}
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Max Amount</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.max_amount || 0}
                </div>
              </div>
            </div>
          </div>
          <div className='col-6'>
            <div className='form-group row'>
              <div className='col-4'>
                <label className='control-label'>First Order Only</label>
              </div>
              <div className='col-8'>
                {String(this.props.detail.first_order_only)}
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-4'>
                <label className='control-label'>First User Only</label>
              </div>
              <div className='col-8'>
                {String(this.props.detail.first_user_only)}
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-4'>
                <label className='control-label'>Start At</label>
              </div>
              <div className='col-8'>
                {moment(this.props.detail.start_at).format('DD/MM/Y hh:mm A')}
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-4'>
                <label className='control-label'>End At</label>
              </div>
              <div className='col-8'>
                {moment(this.props.detail.end_at).format('DD/MM/Y hh:mm A')}
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-4'>
                <label className='control-label'>Description</label>
              </div>
              <div className='col-8'>
                <p>{this.props.detail.description || '-'}</p>
              </div>
            </div>
            <div className='form-group'>
              <div className='row'>
                <div className='col-4'>
                  <label htmlFor='image' className='control-label'>Image File</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.image_url ? <img alt={this.props.detail.image_file} title={this.props.detail.image_file} className='img-responsive' src={this.props.detail.image_url} style={{ maxWidth: '100%' }} /> : 'No Image'}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <button className='btn btn-primary' onClick={() => this._toggleModal('view-user')}>View Users</button>

            <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-user'} onClose={this._toggleModal} closeOnOverlayClick>
              <section className='section' style={{ width: '80vw' }}>
                <div className='title-block'>
                  <h3>List User
                    <button onClick={() => this._fetchClaimers()} className='ml-2 btn btn-primary'>Reload</button>
                    {(this.props.coupon.fetching || this.props.coupon.processing) &&
                      <div className='badge badge-info ml-2'>{this.props.coupon.fetching ? 'Loading' : 'Processing'} ...</div>
                    }
                  </h3>
                </div>
                <div className='table-responsive'>
                  <table className='table table-hover table-striped'>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Country</th>
                        <th>Phone number</th>
                        <th>Order ID</th>
                        <th>Total Order</th>
                        <th>Total Discount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.coupon.detail && !this.props.coupon.detail.coupon_history
                        ? <tr>
                          <td colSpan='9' className='text-center'>
                            - No Data -
                          </td>
                        </tr>
                        : this.props.coupon.detail.coupon_history.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.user.first_name || '-'}</td>
                            <td>{item.user.last_name || '-'}</td>
                            <td>{item.user.email || '-'}</td>
                            <td>{item.user.country_code || '-'}</td>
                            <td>{ item.user.country_calling_code + item.user.phone_number || '-'}</td>
                            <td>{item.order_id || '-'}</td>
                            <td>{item.order.final_amount || '-'}</td>
                            <td>{item.order.discount_amount || '-'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
                <div className='text-center'>
                  <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
                </div>
              </section>
            </Modal>
          </div>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  coupon: state.coupon
})

const dispatchToProps = (dispatch) => ({
  getDetail: (data) => dispatch(CouponActions.couponDetailRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ViewCoupon)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/ViewCoupon.js